import config from "./aws-exports"; // 追加
export const getUserId = () => {
    // return localStorage.userId
    return localStorage[`CognitoIdentityServiceProvider.${config.aws_user_pools_web_client_id}.LastAuthUser`]
}